import { useTranslation } from 'react-i18next';

import { List, ListSubheader } from 'netline-ui';
import { OthersMenuItem } from 'types';

import MobileOthersMenuItem from './MobileOthersMenuItem';

type MobileOthersMenuProps = {
  items: OthersMenuItem[];
};

const MobileOthersMenu = ({ items }: MobileOthersMenuProps) => {
  const { t } = useTranslation();

  return (
    <List
      aria-labelledby="MobileOthersMenu-list"
      subheader={
        <ListSubheader component="div" id="MobileOthersMenu-subheader">
          {t('mobileNavigation.others')}
        </ListSubheader>
      }
    >
      {items.map((item) => (
        <MobileOthersMenuItem key={item.id} item={item} />
      ))}
    </List>
  );
};

export default MobileOthersMenu;
